import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {CreationType} from '../types/CreationType';

export const useGetCreation = () => {
  const [creation, setCreation] = useState<CreationType[]>([]);
  const [creationLoading, setCreationLoading] = useState<boolean>(false);

  const getCreation = async () => {
    setCreationLoading(true);

    try {
      const response = await axios.get(URLS.GET_CREATION_LOCAL);
      setCreation(response.data.creation);
    } catch (error) {
      console.error(error);
    } finally {
      setCreationLoading(false);
    }
  };

  useEffect(() => {
    getCreation();
  }, []);

  return {creationLoading, creation};
};
